var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.001,
    height: 7.49,
    viewBox: "0 0 14.001 7.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "up-arrow",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M20.257,40.745a.5.5,0,0,1-.7,0l-6.151-6.163L7.244,40.745a.495.495,0,1,1-.7-.7l6.5-6.5a.483.483,0,0,1,.35-.145.5.5,0,0,1,.35.145l6.5,6.5a.485.485,0,0,1,.013.7Z",
    transform: "translate(-6.399 -33.4)",
    fill: "#666e87"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/up-arrow.69e6fd2a5b086e43c4f4a20ed9981510.svg";
export { ForwardRef as ReactComponent };